import { useMemo } from "react"
import { StyleSheet } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base from "../../base"

export const useSettingsColumnStyles = () => {
  const isMobile = useMediaQuery(Base.constants.mobile)
  const isTablet = useMediaQuery(Base.constants.tablet)

  const columnContainerStyles = useMemo(() => {
    if (isMobile) {
      return styles.main
    }
    return isTablet ? styles.main_md : styles.main_lg
  }, [isTablet, isMobile])

  return columnContainerStyles
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    paddingTop: 20,
    marginHorizontal: Base.constants.hmargin.sm,
  },

  main_lg: {
    flex: 0.4,
    marginHorizontal: Base.constants.hmargin.md,
  },

  main_md: {
    flex: 0.4,
    marginHorizontal: Base.constants.hmargin.md / 1.75,
  },
})
